<!-- @format -->
<template>
  <b-card title="文章类型添加">
    <validation-observer ref="createArticleClass">
      <b-form>
        <b-row md="12">
          <b-col md="4">
            <b-form-group label-align="center" label="文章类型名称" label-cols="1" label-cols-md="3" content-cols="6" content-cols-md="8">
              <validation-provider #default="{ errors }" name="文章类型名称" rules="required">
                <b-form-input v-model="editData.title" :state="errors.length > 0 ? false : null" placeholder="输入文章类型名称" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row md="12">
          <b-col md="4">
            <b-form-group label-align="center" label="文章类型排序" label-cols="1" label-cols-md="3" content-cols="6" content-cols-md="8">
              <validation-provider #default="{ errors }" name="文章类型排序" rules="required">
                <b-form-input v-model="editData.sort" :state="errors.length > 0 ? false : null" placeholder="输入文章类型顺序" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label-align="center" label="文章类型状态" label-cols="1" label-cols-md="3" content-cols="6" content-cols-md="8">
              <b-form-radio-group
                v-model="editData.status"
                :options="[
                  {
                    text: '正常',
                    value: 1,
                  },
                  {
                    text: '禁用',
                    value: 0,
                  },
                ]"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-button variant="primary" type="submit" @click.prevent="validationForm" :disabled="isRequest"> 提交 </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { reactive, ref, onUnmounted, getCurrentInstance } from '@vue/composition-api'
// 获取当前页面实例
import { required, url } from '@core/utils/validations/validations'

import store from '@/store'
import BrandManagerModule from '@/views/GeneralManagement/ProductManager/Brand/BrandManagerModule'
import { useRouter } from '@core/utils/utils'

export default {
  name: 'BrandCreate',
  components: {
    BCard,
  },
  setup() {
    const INVOICE_APP_STORE_MODULE_NAME = 'artc-module'
    const { router } = useRouter()
    const { proxy } = getCurrentInstance()

    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, BrandManagerModule)
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })
    const isRequest = ref(false)
    const editData = reactive({
      title: '',
      url: '',
      status: 1,
    })
    const createArticleClass = ref(null)

    const validationForm = () => {
      isRequest.value = true
      createArticleClass.value
        .validate()
        .then(res => {
          if (res) {
            store.dispatch('artc-module/createInvoices', { ...editData }).then(response => {
              if (response.code == 0) {
                proxy.$bvToast.toast('添加成功', {
                  title: '提示',
                  variant: 'success',
                  solid: true,
                })
                setTimeout(() => {
                  isRequest.value = false
                  router.back()
                }, 2000)
              }
            })
          } else {
            isRequest.value = false
          }
        })
        .catch(() => {
          isRequest.value = false
          console.log('validationForm error')
        })
    }

    return {
      validationForm,

      editData,
      createArticleClass,

      isRequest,
      required,
      url,
    }
  },
}
</script>

<style scoped></style>
